import React from 'react';


const ButtonGroupToggle = ({options, selectedOption, onOptionSelect}) => {


    return (
        <div className="button-group-toggle">
            { options.map(option => (
                <button key={`opt_${option.label}`} className={`${option.value === selectedOption.value ? 'active' : null}`} onClick={() => onOptionSelect(option)}>{option.label}</button>
            ))}
        </div>
    );
}

ButtonGroupToggle.defaultProps = {
    options: [],
    selectedOption: null,
    onOptionSelect: () => {},
}

export default ButtonGroupToggle;